import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PLAN_Z_BOGO_FLAG_NAME } from '../constants'
import { useExperiment } from './useExperiment'

export const useTrackExperimentViewed = () => {
  const { isOn } = useExperiment()

  useEffect(() => {
    if (!isOn) return

    trackExperimentViewed(PLAN_Z_BOGO_FLAG_NAME)
  }, [isOn])
}
